/**
 * Release gate for 8 Islas / Batallas.
 *
 * Duels are not approved for public release. Keep the shared gate closed so
 * the page shows "Próximamente disponible" and background queries stay paused.
 * Environment variables, QA mode and browser storage cannot enable this release.
 */
export const isDuelsEnabled = () => false;
